const initialState = {
    data: {},
    loading: false,
    error: null,
    brands:{}
};

const exploreReducer = (state = initialState, action) => {

    switch (action.type) {
        case 'FETCH_EXPLORE_DATA_REQUEST':
            return {
                ...state,
                loading: true,
            };
        case 'FETCH_EXPLORE_DATA_SUCCESS':
            return {
                ...state,
                loading: false,
                data: action.payload,
            };
        case 'FETCH_EXPLORE_DATA_FAILURE':
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case 'FETCH_EXPLORE_ALL_BRANDS_REQUEST':
            return {
                ...state,
                loading: true,
            };
        case 'FETCH_EXPLORE_ALL_BRANDS_SUCCESS':
            if(action?.payload?.query?.currentPage > 0) {
                return {
                    ...state,
                    loading: false,
                    brands: {
                        brands: [...state?.brands?.brands, ...action?.payload?.exploreData?.brands],
                        pagination: action?.payload?.exploreData?.pagination
                    }
                };
            }
            return {
                ...state,
                loading: false,
                brands: action.payload.exploreData,
            };
        case 'FETCH_EXPLORE_ALL_BRANDS_FAILURE':
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case 'RESET_EXPLORE_ALL_BRANDS_REQUEST':
            return {
                ...state,
                loading: false,
                error: null,
                brands:{}
            };
        default:
            return state;
    }
};

export default exploreReducer;
